import React, { useEffect, useRef, useState } from 'react';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Form, Table, Row, Col, Button } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GrDocumentExcel } from 'react-icons/gr';
import PaginationInPage from '../Pagination';
import { getStoredData, get_auth_key } from '../../util';
import Company from '../../components/company';
import { get } from '../../services/apiController';
import Breadcrumb from '../../components/Breadcrumb';
import moment from 'moment';
import { GetFinancialYearsArray } from '../../util/helper';

const DepreciationReport = ({ type }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  // const [locationList, setLocationList] = useState([]);
  // const [assetCategoryList, setAssetCategoryList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const storedData = JSON.parse(getStoredData(get_auth_key()));
  // const [locationType, setLocationType] = useState('');

  const admins = ['admin', 'super-admin', 'fixed-asset-admin'].includes(storedData.role);

  const [state, setState] = useState({
    companyId: !admins ? storedData?.companyId || '' : '',
    act: '',
    financialYear: '',
    sQuery: '',
  });
  const clickToDownload = useRef(null);

  // function getLocations() {
  //   try {
  //     get(`/branches`).then((response) => {
  //       setLocationList(response?.data?.rows);
  //       if (!admins) {
  //         const data = response?.data?.rows?.find((item) => {
  //           return item.id === storedData?.locationId[0];
  //         });
  //         setLocationType(data?.type);
  //       }
  //     });
  //   } catch (err) {
  //     toast.error(err.response.data.data.message);
  //   }
  // }

  // function getAssetCategories() {
  //   try {
  //     get(`/asset-categories`).then((response) => {
  //       setAssetCategoryList(response.data.rows);
  //     });
  //   } catch (err) {
  //     toast.error(err.response.data.data.message);
  //   }
  // }

  // useEffect(() => {
  //   getLocations();
  //   getAssetCategories();
  // }, []);

  const getDepreciationReportData = (conditionType = '') => {
    try {
      let url = `/assets/depreciation-report/?companyId=${state.companyId}&act=${state.act}&financialYear=${state.financialYear}&type=${type}&sQuery=${state.sQuery}`;
      if (conditionType === 'download') {
        url += `&conditionType=${conditionType}`;
      } else {
        url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
      }
      get(url).then((res) => {
        if (conditionType === 'download') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setFilteredList(res?.data.rows);
          setTotalRecords(res.data.count);
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err.message);
    }
  };

  const handleRefresh = () => {
    getDepreciationReportData();
  };

  const onFilterChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  useEffect(() => {
    getDepreciationReportData();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Fixed Asset' },
          { link: '#', title: 'Reports' },
          { link: '#', title: type === 'consolidated-report' ? 'Consolidated Depreciation Report' : 'Depreciation Report' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color">
          <div className="col-3">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              {type === 'consolidated-report' ? 'Consolidated Report' : 'Depreciation Report'} | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="col-9">
            <div className="card-header-actions">
              <Row className="w-100">
                {type === 'full-report' && (
                  <Col xs={3}>
                    <Form.Control
                      name="sQuery"
                      value={state.sQuery}
                      onChange={onFilterChange}
                      type="search"
                      placeholder="Search by asset name"
                    />
                  </Col>
                )}
                <Col xs={type === 'full-report' ? 2 : 3}>
                  <Form.Select name="act" value={state.act} onChange={onFilterChange} placeholder="ROD Act" className="input">
                    <option value="">Select ROD Act</option>
                    <option value="company">Company Act</option>
                    <option value="it">IT Act</option>
                  </Form.Select>
                </Col>
                <Col xs={type === 'full-report' ? 2 : 3}>
                  <Company name="companyId" company={state.companyId} label="Company" onChange={onFilterChange} />
                </Col>
                <Col xs={type === 'full-report' ? 2 : 3}>
                  <Form.Select
                    name="financialYear"
                    value={state.financialYear}
                    onChange={onFilterChange}
                    placeholder="Financial Year"
                    className="input"
                  >
                    <option value="">Select Financial Year</option>
                    {GetFinancialYearsArray(2024).map((year) => (
                      <option key={year} value={year}>
                        {year}-{year + 1}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={2} className="d-flex align-items-center justify-content-end" style={{ paddingRight: '0' }}>
                  <Button className="btn btn-info btn-sm" onClick={() => handleRefresh()}>
                    Filter
                  </Button>
                </Col>
                {totalRecords > 0 && (
                  <Col xs={1}>
                    <GrDocumentExcel
                      onClick={() => getDepreciationReportData('download')}
                      style={{ width: '70px', height: '30px', cursor: 'pointer' }}
                      title="Download depreciation report"
                      className="react-icons green"
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-wrapper ">
            {totalRecords === 0 && (
              <div className="container d-flex align-items-center justify-content-center">
                <h5 className="text-danger">No Records Found</h5>
              </div>
            )}
            <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        {totalRecords > 0 && (
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              {type === 'consolidated-report' ? (
                <div className="col">
                  <Table className="text-center" responsive striped bordered>
                    <thead>
                      <tr>
                        <th rowSpan={2} style={{ verticalAlign: 'middle' }}>
                          Particulars
                        </th>
                        <th colSpan={4}>Gross Block</th>
                        <th colSpan={4}>Accumulated Depreciation and Amortization</th>
                        <th colSpan={2}>Net Block</th>
                      </tr>
                      <tr>
                        {filteredList?.header?.map((title, index) => {
                          return <th key={index}>{title}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList?.data?.map((item, index) => {
                        return (
                          <tr key={item?.id}>
                            <td style={{ fontWeight: 'bold' }}>{item?.category}</td>
                            <td>{item?.totalGrossBlockOB.toFixed(2)}</td>
                            <td>{item?.totalAdditionsThisYear.toFixed(2)}</td>
                            <td>{item?.totalDisposalAmount.toFixed(2)}</td>
                            <td>{item?.totalGrossBlockCB.toFixed(2)}</td>
                            <td>{item?.totalDepreciationLastYear.toFixed(2)}</td>
                            <td>{item?.totalAccumulatedDepreciation.toFixed(2)}</td>
                            <td>-</td>
                            <td>{item?.totalDepreciationThisYear.toFixed(2)}</td>
                            <td>{item?.totalNetBlockEnd.toFixed(2)}</td>
                            <td>{item?.totalNetBlockStart.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="col">
                  <Table responsive striped bordered>
                    <thead>
                      <tr>
                        <th>Location</th>
                        <th>Asset Name</th>
                        <th>Asset Number</th>
                        <th>Quantity</th>
                        <th>Category</th>
                        <th>TAN/INT</th>
                        <th>Bill No</th>
                        <th>Vendor</th>
                        <th>Purchase Date</th>
                        <th>Put to use Date</th>
                        <th>{`Gross Block b/f (01-04-${state.financialYear})`}</th>
                        <th>Additions During the Year</th>
                        <th>Deletions During the Year</th>
                        <th>{`Gross Block 31-03-${+state.financialYear + 1}`}</th>
                        <th>{`Accumulated b/f (01-04-${state.financialYear})`}</th>
                        <th>Depreciation for the Year</th>
                        <th>Depreciation on Deletions During the Year</th>
                        <th>{`Accumulated Depreciation 31-03-${+state.financialYear + 1}`}</th>
                        <th>{`Net Block 31-03-${+state.financialYear + 1}`}</th>
                        <th>{`Net Block 01-04-${state.financialYear}`}</th>
                        <th>Number of Days from put to use</th>
                        <th>Salvage Value @5%</th>
                        <th>Useful Life</th>
                        <th>{`Remaining useful life on 01-04-${state.financialYear}`}</th>
                        <th>ROD (%)</th>
                        <th>Quantity of Asset Disposed</th>
                        <th>Date of Disposal</th>
                        <th>Gross Block Value of Asset Disposed</th>
                        <th>Accumulated Depreciation on Asset Disposed</th>
                        <th>Net Block Value of Asset Disposed</th>
                        <th>Sale Value</th>
                        <th>Profit/Loss</th>
                        <th>Loss on Disposal</th>
                        <th>Quantity (Remaining)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList?.map((item, index) => {
                        const salvageValue = ((item.grossBlockCB * 5) / 100).toFixed(2);
                        // Calculate remaining quantity, ensuring it doesn't go negative
                        const remainingQuantity = +item.quantity === -1 ? 'LS' : Math.max(0, item.quantity - (item.disposedQuantity || 0));

                        return (
                          <tr key={item?.id}>
                            <td>{item.location}</td>
                            <td>{item.assetName}</td>
                            <td>{item.assetNumber}</td>
                            <td>{+item.quantity === -1 ? 'LS' : item.quantity}</td>
                            <td>{item.category}</td>
                            <td style={{ textTransform: 'capitalize' }}>{item.categoryType}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{item.billNumber}</td>
                            <td>{item.vendorName}</td>
                            <td>{moment(item.purchaseDate).format('DD/MM/YYYY')}</td>
                            <td>{moment(item.putToUseDate).format('DD/MM/YYYY')}</td>
                            <td>{parseFloat(item.grossBlockOB) < 0 ? 0 : item.grossBlockOB}</td>
                            <td>{parseFloat(item.additionsThisYear) < 0 ? 0 : item.additionsThisYear}</td>
                            <td>{parseFloat(item.disposalAmount) < 0 ? 0 : item.disposalAmount}</td>
                            <td>{item.disposalDate ? '-' : parseFloat(item.grossBlockCB) < 0 ? 0 : item.grossBlockCB}</td>
                            <td>{parseFloat(item.depreciationLastYear) < 0 ? 0 : item.depreciationLastYear}</td>
                            <td>{parseFloat(item.depreciationThisYear) < 0 ? 0 : item.depreciationThisYear}</td>
                            <td>{item.depreciationOnDisposal > 0 ? item.depreciationOnDisposal : '-'}</td>
                            <td>{parseFloat(item.accumulatedDepreciation) < 0 ? 0 : item.accumulatedDepreciation}</td>
                            <td>{parseFloat(item.netBlockEnd) < 0 ? 0 : item.netBlockEnd}</td>
                            <td>{parseFloat(item.netBlockStart) < 0 ? 0 : item.netBlockStart}</td>
                            <td>{item.daysFromPutToUse}</td>
                            <td>{salvageValue}</td>
                            <td>{item.life}</td>
                            <td>{item.remainingLife}</td>
                            <td>{item.rodCompanyAct}</td>
                            <td>{item.disposedQuantity || '-'}</td>
                            <td>{item.disposalDate ? moment(item.disposalDate).format('DD/MM/YYYY') : '-'}</td>
                            <td>{parseFloat(item.disposalAmount) < 0 ? 0 : item.disposalAmount || '-'}</td>
                            <td>
                              {item.disposalDate
                                ? Math.max(
                                  0,
                                  (parseFloat(item.depreciationLastYear) + parseFloat(item.depreciationThisYear)) *
                                  (item.disposedQuantity / item.quantity)
                                )
                                : '-'}
                            </td>
                            <td>
                              {item.disposalDate
                                ? Math.max(
                                  0,
                                  parseFloat(item.disposalAmount) -
                                  (parseFloat(item.depreciationLastYear) + parseFloat(item.depreciationThisYear)) *
                                  (item.disposedQuantity / item.quantity)
                                )
                                : '-'}
                            </td>
                            <td>{parseFloat(item.saleValue) < 0 ? 0 : item.saleValue || '-'}</td>
                            <td>
                              {item.disposalDate
                                ? parseFloat(item.saleValue || 0) -
                                Math.max(
                                  0,
                                  parseFloat(item.disposalAmount) -
                                  (parseFloat(item.depreciationLastYear) + parseFloat(item.depreciationThisYear)) *
                                  (item.disposedQuantity / item.quantity)
                                )
                                : '-'}
                            </td>
                            <td>
                              {item.disposalDate ? Math.max(0, parseFloat(item.grossBlockOB) - parseFloat(item.disposalAmount)) : '-'}
                            </td>
                            <td>{remainingQuantity}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <PaginationInPage
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={totalRecords}
                    TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default DepreciationReport;
